<template>
  <TemplateView>
    <div class="container">
      <div class="d-flex flex-wrap gap-5">
        <v-hover v-slot="{ hover }">
          <v-btn
            class="rounded-xl mt-5"
            :class="projectName ? 'white--text' : 'primary--text'"
            small
            min-width="20"
            :color="projectName ? 'primary' : 'white'"
            :depressed="!hover"
            @click="onSort()"
          >
            <IconSortAlphabetical :sort="projectName" />
          </v-btn>
        </v-hover>
        <BaseInput
          v-if="filter.status.list.length > 1"
          :label="
            localStorage.translations.pages['sales_project']['planned_resources-labels'][
              'status-proekta'
            ]
          "
          type="autocomplete"
          v-model="filter.status.value"
          :items="filter.status.list"
          placeholder="—"
          multiple
          minimize
          small-chips
          clearable
          @change="resetPageData()"
        />
        <BaseInput
          v-if="userType !== 'subscriber'"
          :label="
            localStorage.translations.pages['sales_project']['project_client-labels']['klient']
          "
          type="autocomplete"
          v-model="filter.client.value"
          :items="filter.client.list"
          placeholder="—"
          multiple
          minimize
          small-chips
          clearable
          @change="resetPageData()"
          max-width="500px"
        />
        <div>
          <label class="primary--text f14 fw500 temp">{{
            localStorage.translations.pages['statistic_project'].tables.period
          }}</label>
          <v-menu
            ref="menu"
            v-model="menu"
            :close-on-content-click="false"
            transition="scale-transition"
            offset-y
            max-width="290px"
            min-width="290px"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                hide-details
                v-model="dateRangeText"
                filled
                height="30"
                v-bind="attrs"
                readonly
                clearable
                prepend-inner-icon="today"
                placeholder="—"
                v-on="on"
                class="temp"
                @click:clear=";(filter.period = []), resetPageData()"
              />
            </template>
            <v-date-picker
              :locale="$cookies.get('languageSelect').key"
              v-model="filter.period"
              range
              no-title
              show-week
              first-day-of-week="1"
              class="temp"
            >
              <BaseButton
                class="ml-auto mr-0"
                :text="localStorage.translations.pages.common.buttons.confirm"
                :disabled="filter.period.length < 1"
                @click=";(menu = false), resetPageData()"
              />
            </v-date-picker>
          </v-menu>
        </div>
      </div>
      <TemplatePageGrid :items="objectDataCurrent.data || []" :loading="loadingAnimation"
            :page-data="objectDataCurrent">
        <div class="projectGrid">
          <TimeControlCard
            v-for="(project, index) in objectDataCurrent.data"
            :project="project"
            :works="project.project_work_types"
            :key="index"
            :index="index"
            :extra_works="project.extra_works"
          />
        </div>
      </TemplatePageGrid>
    </div>
  </TemplateView>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex'
import TemplateView from 'components/templates/TemplateView'
import TimeControlCard from 'components/timeControl/TimeControlCard'
import BaseInput from 'components/base/BaseInput.vue'
import TemplatePageGrid from 'components/templates/TemplatePageGrid.vue'
import IconSortAlphabetical from '../../../components/icons/IconSortAlphabetical.vue'

export default {
  name: 'timeControl',
  data: () => ({
    dropPage: false,
    menu: false,
    projectName: '',
    filter: {
      status: {
        list: [],
        value: [],
      },
      client: {
        list: [],
        value: [],
      },
      period: [],
    },
  }),
  components: {
    IconSortAlphabetical,
    BaseInput,
    TemplateView,
    TimeControlCard,
    TemplatePageGrid,
  },
  computed: {
    ...mapGetters('workClientProject', [
      'workClientProjectProgress',
      'workClientProjectGrid',
      'workClientProjectGrid_filter',
      'pageData'
    ]),
    ...mapGetters('user', ['userType']),
    ...mapGetters(['loadingAnimation']),
    objectDataToArray() {
      let array = []
      for (var item in this.workClientProjectProgress) {
        let object = this.workClientProjectProgress[item]
        object.id = Number.parseInt(item)
        let objectWorkTypePeriodsLength = false
        for (let work in object.project_work_types) {
          if (!Array.isArray(object.project_work_types[work].periods)) {
            objectWorkTypePeriodsLength = true
            break
          }
        }
        if (objectWorkTypePeriodsLength) array.push(object)
      }
      if(this.projectName === 'desc')
       return array.sort(function (a, b) {
         let nameA = a.name.toUpperCase();
         let nameB = b.name.toUpperCase();
           return nameA < nameB === true ? 1 : -1
       })
       if(this.projectName === 'asc')
       return array.sort(function (a, b) {
         let nameA = a.name.toUpperCase();
         let nameB = b.name.toUpperCase();
           return nameA < nameB === true ? -1 : 1
       })
       return array
       
    },

    dateRangeText() {
      let dates = [...this.filter.period]
      if (dates[0]) {
        dates[0] = this.$formatDate(dates[0])
      }
      if (dates[1]) {
        dates[1] = this.$formatDate(dates[1])
      }
      return dates.join(' - ')
    },

    objectDataCurrent() {
      let allData = this.objectDataToArray || []
      const res = []
      if(this.$route.query.limit !== 0){
      for (let i = 0; i < allData.length; i += this.$route.query.limit) {
        const chunk = allData.slice(i, i + this.$route.query.limit)
        res.push(chunk)
      }
      } else {
        res.push(this.objectDataToArray)
      }
      let result = {}
      result.data = res[this.$route.query.page - 1]
      result.amount = allData.length
      result.perPage = this.$route.query.limit
      result.currentPage = this.$route.query.page
      result.lastPage = res.length

      return result
    },
  },
  created() {
    this.getFilters()
    this.onDownloadPageData()
  },
  watch: {
    '$route.query.search'() {
      this.resetPageData()
    },
    '$route.query'() {
      this.onDownloadPageData()
    },
  },
  methods: {
    ...mapActions('workClientProject', [
      'onWorkClientProjectProgress',
      'onWorkClientProjectGrid_filter',
    ]),
    ...mapActions('workClient', ['onWorkClientAll']),
    ...mapMutations(['setLoadingAnimation']),
    resetPageData() {

      console.log('pushParams')
      let query = Object.assign({}, this.$route.query)
      query['page'] = 1
      query['limit'] = this.$route.query.limit
      let local = localStorage.getItem('queryParams')
      local = local ? JSON.parse(localStorage.getItem('queryParams')) : {}
      local[this.$route.name] = query
      localStorage.setItem('queryParams', JSON.stringify(local))
      this.$router.push({ query }).catch(() => {
        this.pushActive = false
      })

      this.onDownloadPageData()
    },
    async getFilters() {
      this.filter.status.list.push(
        {
          id: 'pending',
          name: this.localStorage.translations.pages.projects_status.status['v-ozhidanii'] || '',
        },
        {
          id: 'in_progress',
          name: this.localStorage.translations.pages.projects_status.status['v-rabote'] || '',
        },
      )
      await this.onWorkClientAll().then((res) => {
        this.filter.client.list = res.data.data
      })
    },
    async onDownloadPageData() {
      this.setLoadingAnimation(true)
      let data = {
        filter: {
          status: this.filter.status.value.join(','),
        },
      }
      if (this.filter.client.value.length)
        data.filter.work_client_id = this.filter.client.value.join(',')
      if (this.filter.period.length) data.filter.period = this.filter.period.join(',')
      if (this.$route.query.search) data.search = this.$route.query.search
      await this.onWorkClientProjectProgress({ filter: data.filter, search: data.search }).then(
        () => {
          this.setLoadingAnimation(false)
        },
      )
    },
    onSort() {
      
      this.projectName =
        this.projectName === 'asc' ? 'desc' : this.projectName === 'desc' ? '' : 'asc'

    },
  },
}
</script>

<style lang="scss" scoped>
.wrap {
  display: grid;
  grid-row-gap: 40px;

  .projectGrid {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    grid-gap: 24px;
    @media #{map-get($display-breakpoints, 'md-only')} {
      grid-template-columns: repeat(3, 1fr);
    }
    @media #{map-get($display-breakpoints, 'sm-only')} {
      grid-template-columns: repeat(2, 1fr);
    }
    @media #{map-get($display-breakpoints, 'xs-only')} {
      grid-template-columns: repeat(1, 1fr);
      grid-gap: 10px;
    }
  }
  // .projectNone {
  //     height: 300px;
  //     display: grid;
  //     justify-content: center;
  //     align-content: center;
  // }
}
label.temp {
  display: block;
  margin-bottom: 5px;
  line-height: 16px !important;
}
:deep() .v-input.v-text-field .v-input__slot:not(.v-textarea) {
  min-height: 30px !important;
  border-radius: 10px !important;
}
.temp {
  :deep() .v-input__slot{
  width: max-content !important;
  }
}
</style>
